// https://stackoverflow.com/a/29696509/1084192
const ua = window?.navigator?.userAgent;
const isIOS = !!ua?.match(/iPad/i) || !!ua?.match(/iPhone/i);
const isWebkit = !!ua?.match(/WebKit/i);

export const isIOSSafari = isIOS && isWebkit && !ua?.match(/CriOS/i);
